import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import UserCar from '@/types/table/userCar';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface UserCarData extends UserCar {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class UserCarController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<UserCarData>>(API_CONTEXT + '/app/userCar/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<UserCarData>(API_CONTEXT + '/app/userCar/view', params, httpOptions);
  }
  static occupationInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<UserCarData>(API_CONTEXT + '/app/userCar/occupationInformation', params, httpOptions);
  }

  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/userCar/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/userCar/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/userCar/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/deleteBatch', params, httpOptions);
  }
  static startOnlyUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/startOnly/UserCar', params, httpOptions);
  }
  static startWithBusinessKeyUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/startWithBusinessKey/UserCar', params, httpOptions);
  }
  static startAndTakeUserTaskUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/startAndTakeUserTask/UserCar', params, httpOptions);
  }
  static startAndSaveDraftUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/startAndSaveDraft/UserCar', params, httpOptions);
  }
  static submitUserTaskUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/submitUserTask/UserCar', params, httpOptions);
  }
  static viewTaskBusinessDataUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/userCar/viewTaskBusinessData/UserCar', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/userCar/viewHistoricTaskBusinessData/UserCar', params, httpOptions);
  }
  static listWorkOrderUserCar(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/listWorkOrder/UserCar', params, httpOptions);
  }

  static userCarOccupationReason(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/userCar/userCarOccupationReason', params, httpOptions);
  }

  static viewCopyBusinessData(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/userCar/viewCopyBusinessData', params);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

   static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post<TableData<UserCarData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
      }

}
